export default __webpack_public_path__ + "static/media/LOB1.ce489983.jpg";